module.exports = __webpack_public_path__ + "img/enseption_06.ce5996c8.png";